import React from "react";
import { graphql, gql, compose } from "react-apollo";
import withStyles from "isomorphic-style-loader/lib/withStyles";

import Loader from "../../../../components/Loader/Loader";
import s from "./WhyHostBlock7.css";
import FaqForm from "../../../../components/siteadmin/faqs/faqs";
import getWhyHostPageSettings from "./getWhyHostPageSettings.graphql";
import WhyHostFormBlock7 from "../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock7/WhyHostFormBlock7"
import getHostListingWebsiteFaq from "./getHostListingWebsiteFaqSettings.graphql";

class WhyHostBlock7 extends React.Component {
  static defaultProps = {
    data: {
      loading: false,
    },
  };

  render() {
    const {
      data: { loading, getWhyHostPage, getHostListingWebsiteFaq },
      type,
      title
    } = this.props;
    let faqDescription = "";
    let settingsCollection = {};
    let flattenFaq = {};
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      if (type === "faqs") {
        settingsCollection = getHostListingWebsiteFaq?.dataList;
        faqDescription = getHostListingWebsiteFaq?.faqDescription?.value;
        const flattenFaqs = (faqs) => {
          return {
            faqItems: faqs?.map((item) => ({
              title: item.question || "",
              content: item.answer || "",
              id: item.id || "",
            })),
          };
        };

        // Example
        flattenFaq = flattenFaqs(settingsCollection);
        return (
          <FaqForm
            initialValues={{ ...flattenFaq, faqsDescription: faqDescription }}
            type={type}
            flattenFaq={settingsCollection}
            title={title}
          />
        );
      } else {
        getWhyHostPage.map((item, key) => {
          settingsCollection[item.name] = item.value;
        });
        return (
        <WhyHostFormBlock7 initialValues={settingsCollection} type={type} title={title}/>
      );
      }
    }
  }
}

const withData = (type) => {
  return graphql(
    type === "faqs" ? getHostListingWebsiteFaq : getWhyHostPageSettings,
    {
      options: {
        fetchPolicy: "network-only",
        ssr: false,
      },
      props: ({ data }) => ({
        data,
        type, // pass down the type to the form
      }),
    }
  );
};

const WhyHostBlock7Wrapper = ({ type }) => {
  const query =
    type === "faqs" ? getHostListingWebsiteFaq : getWhyHostPageSettings;

  const WithData = graphql(query, {
    options: {
      fetchPolicy: "network-only",
      ssr: false,
    },
    props: ({ data }) => ({
      data,
      type,
    }),
  })(WhyHostBlock7);

  return <WithData type={type} />;
};

export default withStyles(s)(WhyHostBlock7Wrapper);
